import { render, staticRenderFns } from "./Rohs.vue?vue&type=template&id=35076bec&"
import script from "./Rohs.vue?vue&type=script&lang=js&"
export * from "./Rohs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports